import { Suspense } from 'react';
import { home } from 'routes/config';
import { Navigate, Route, Routes } from 'react-router-dom';
import { performanceRoutes } from './Performance';
import { callLogsRoutes } from './CallLogs';
import { configureRoutes } from './Configure';
import Spinner from 'components/Common/Spinner';

export default function AgentRoutes() {
  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route index={true} element={<Navigate to={home.performance} replace />} />
        {performanceRoutes}
        {callLogsRoutes}
        {configureRoutes}
        <Route path='*' element={<Navigate to='/404' replace />} />
      </Routes>
    </Suspense>
  );
}
